<template>
  <div>
    <PrimaryBox :flag="true">
      <template slot="title">应急动态</template>
      <div class="content">
        <div class="outBox">
          <div class="tops">
            <div class="introduction">
              <el-image v-if="firstDescription" class="img" lazy
                        :src="IconRedList[1]"></el-image>
              <p class="title">{{ firstDescription.eventTitle }}</p>
              <p class="labelIcon" v-if="firstDescription">
                <el-tag effect="plain" color="#4A1515" :hit="true" size="mini" type="danger"
                        v-if="firstDescription.status==='未处置'"> 未处置
                </el-tag>
                <el-tag v-else-if="firstDescription.status==='处置中'" :hit="true" size="mini" color="#ccc" type="info">
                  处置中
                </el-tag>
                <el-tag :hit="true" size="mini" type="success" color="#333333"
                        v-else> {{ firstDescription.status }}
                </el-tag>
              </p>
              <span class="address">{{ firstDescription.eventDescription }}</span>
              <span class="times">{{
                  firstDescription.eventReceptionTime === undefined ? '': $moment(firstDescription.eventReceptionTime).format('yyyy-MM-DD')
                  }}</span>
            </div>
            <div class="timeLineBox">
              <div v-if="timeLineList.length>0">
                <Timeline class="timeLine">
                  <TimelineItem v-for="(item,index) in timeLineList" :key="index" :color="item.color">
                    <Icon v-if="item.createTime" type="ios-checkmark-circle" slot="dot"/>
                    <div><p class="title">{{ item.disposalProcessName }}</p><span
                      class="time">{{
                        item.createTime === null ? '暂无时间' : $moment(item.createTime).format('MM-DD hh:mm')
                      }}</span>
                    </div>
                    <p class="source">{{
                        item.description }}</p>
                  </TimelineItem>
                </Timeline>
              </div>
              <div v-else style="width: 100%;text-align: center;">
                <span style="color: #2b85e4;font-size: 1rem;line-height: 6rem;font-weight: bold;">暂无数据</span>
              </div>
            </div>
          </div>
          <div class="bottoms">
            <VueSeamlessScroll :data="eventList" class="content" :class-option="defaultOption">
              <div v-for="(item,index) in eventList" :key="index" class="itemBox" @click="getEventById(item)">
                <img class="img" :src="IconRedList[1]" alt=""/>
                <p class="title">{{ item.eventTitle }}</p>
                <p class="iconLabel">
                  <el-tag effect="plain" color="#4A1515" :hit="true" size="mini" type="danger"
                          v-if="item.status==='未处置'">未处置
                  </el-tag>
                  <el-tag :hit="true" size="mini" color="#ccc" type="info" v-if="item.status==='处置中'">处置中
                  </el-tag>
                  <el-tag :hit="true" size="mini" type="success" color="#333333"
                          v-if="item.status==='已处置'||item.status==='已完成'">{{ item.status }}
                  </el-tag>
                </p>
                <p class="eventDescription">{{ item.eventDescription }}</p>
                <p class="eventReceptionTime">{{ $moment(item.eventReceptionTime).format('yyyy-MM-DD') }}</p>
              </div>
            </VueSeamlessScroll>

          </div>
        </div>
      </div>
    </PrimaryBox>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import DynamicJianKong from '../../images/dynamic_jiankong.png';
import dynamicYujing from '../../images/dynamic_yujing.png';
import dynamicLukuang from '../../images/dynamic_lukuan.png';
import VueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "EventDynamic",
  components: {
    PrimaryBox,
    VueSeamlessScroll
  },
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  data() {
    return {
      firstDescription: {},
      timeLineList: [],
      IconRedList: [DynamicJianKong, dynamicYujing, dynamicYujing, dynamicLukuang],
      eventList: []
    }
  },
  mounted() {
    this.getEventList()
    this.getFirstDescription()
  },
  methods: {
    getImg(item) {
      let types = item.eventType === null ? '0' : parseInt(item.eventType) > 3 ? '0' : item.eventType;
      return this.IconRedList[parseInt(types)];
    },
    getEventList() {
      this.$http.post('/api/getMessageList', {
        reportingChannels: 1
      }).then(res => {
        console.log('red',res)
        if (res.status === 200) {
          this.eventList = res.data.data;
        }
      })
    },
    getFirstDescription() {
      this.$http.get('/api/getEarliestHandingEvent').then(res => {
        if (res.status === 200) {
          this.firstDescription = res.data;
          this.firstDescription.typeIndex = this.firstDescription.eventType === null ? '0' : parseInt(this.firstDescription.eventType) > 3 ? '0' : this.firstDescription.eventType;
          this.getTimeLineList()
        }
      })
    },
    getTimeLineList() {
      let messaged = this.firstDescription.id;
      this.$http.get(`/api/getMessageReceptionRecordsList/${messaged}`).then(res => {
        if (res.status === 200) {
          this.timeLineList = res.data;
          this.timeLineList[0].color = '#13C8FC'
        }
      })
    },
    getEventById(item) {
      this.$http.get(`/api/messageReceptions/${item.id}`).then(res => {
        this.firstDescription = res.data
      })
      this.$http.get(`/api/getMessageReceptionRecordsList/${item.id}`).then(res => {
        if (res.status === 200) {
          this.timeLineList = res.data;
          if (this.timeLineList.length > 0) {
            this.timeLineList[0].color = '#13C8FC'
          }
        }
      })
      // 在地图上居中显示
      // this.$emit('getEventById', item)
      this.$emit('getEventById', item)
    }
  },
}

</script>

<style scoped lang="less">
@import "EventDynamic.less";
</style>
